/* AquaCo: keep Storeify popup labels scoped to their own form. */
(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    var label = event.target.closest && event.target.closest('label[for]');
    var form = label && label.closest('form');
    if (!form || form.getAttribute('id') !== 'storeify_form_action_1062') return;
    var oldId = label.getAttribute('for');
    var inputs = form.querySelectorAll('[id]');
    var input = null;
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].id === oldId) { input = inputs[i]; break; }
    }
    if (!input || document.getElementById(oldId) === input) return;
    var newId = 'aquaco-popup-1062-' + oldId;
    if (document.getElementById(newId)) return;
    input.id = newId;
    var labels = form.querySelectorAll('label[for]');
    for (var j = 0; j < labels.length; j++) {
      if (labels[j].getAttribute('for') === oldId) labels[j].setAttribute('for', newId);
    }
  }, true);

  /* Show the accepted main enquiry at its new position after the long form collapses. */
  function watchSuccess(form) {
    if (!form || form.getAttribute('id') !== 'storeify_form_action_19356') return;
    var container = document.getElementById('storeify_content_formbuilder_19356');
    if (!container || !window.MutationObserver) return;
    if (container.aquacoSuccessObserver) container.aquacoSuccessObserver.disconnect();
    var timer;
    var observer = new MutationObserver(function () {
      var message = container.querySelector('.storeify-formbuilder-mes.storeify-mes-success');
      if (!message) return;
      observer.disconnect();
      clearTimeout(timer);
      window.requestAnimationFrame(function () {
        message.setAttribute('role', 'status');
        message.style.scrollMarginTop = '140px';
        message.scrollIntoView({ block: 'center', behavior: 'auto' });
      });
    });
    container.aquacoSuccessObserver = observer;
    observer.observe(container, { attributes: true, attributeFilter: ['class'], subtree: true });
    timer = setTimeout(function () { observer.disconnect(); }, 120000);
  }
  document.addEventListener('submit', function (event) { watchSuccess(event.target); }, true);
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.storeify-submit-btn');
    if (button) watchSuccess(button.closest('form'));
  }, true);
}());
